import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent implements OnInit {

  @Input() show:boolean;

  constructor(private spinner:NgxSpinnerService) { }

  ngOnInit(): void {
    
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.show){
      this.spinner.show();
    }else{
      this.spinner.hide();
    }
  }

}
